export default __webpack_public_path__ + "static/Loreal_ContentPro_banner_mobile-9528b5489398308e5578eb1c31a454e2.jpg";